export default __webpack_public_path__ + "static/certificate-marathon-square-8620e1429452606e0b96820470752af9.png";